import map from 'lodash/map'
import reduce from 'lodash/reduce'
import set from 'lodash/set'
import React, { useEffect, useMemo, useState } from 'react'

import { ReactComponent as ToggleOff} from '../../../images/svg/toggle-off.svg'
import { ReactComponent as ToggleOn} from '../../../images/svg/toggle-on.svg'

import { ReactComponent as SelectOff} from '../../../images/svg/selected-no.svg'
import { ReactComponent as SelectOn} from '../../../images/svg/selected-yes.svg'

import { ReactComponent as CheckOff} from '../../../images/svg/checkbox-off.svg'
import { ReactComponent as CheckOn} from '../../../images/svg/checkbox-on.svg'

import { get } from 'lodash'
import {ReactComponent as Close} from '../../../images/svg/x-close.svg'
import { Accordion } from './Accordion'

const SelectedRadio = ({
  selectedComponent,
  primary,
  secondary = 'Secondary Text',
  selected = false,
  onClick,
  icon,
}) => {
  return (
    <div
      onClick={(e) => {
        if (selectedComponent == null) onClick()
      }}
      className={`font-sarabun text-neutral_4 border  rounded-sm   p-4 flex space-x-3 cursor-pointer hover:border-neutral_2 ${
        selected
          ? ' bg-neutral_1 border-neutral_2'
          : ' bg-white border-neutral hover:border-neutral_1'
      }`}
    >
      <div>{icon}</div>
      <div className="grid grid-cols-1 items-start">
        <div className="font-sarabun text-neutral_4 mb-2 text-2xl">{primary}</div>
        <div className="font-sarabun text-neutral_3">{secondary}</div>
        {selectedComponent && selectedComponent}
      </div>
      <div className="flex-grow"></div>
      <div
        className="justify-self-end m-1 justify-items-center"
        onClick={(e) => {
          if (selectedComponent != null) onClick()
        }}
      >
        {selected ? <SelectOn></SelectOn> : <SelectOff></SelectOff>}{' '}
        {selectedComponent != null && selected && <Close></Close>}
      </div>
    </div>
  )
}

const CurrentPlan = ({
  primary = 'Primary Text',
  secondary = 'Secondary Text',
}) => {
  return (
    <div
      className={`font-sarabun text-neutral_4 border  rounded-sm   p-4 flex space-x-3 `}
    >
      <div className="grid grid-cols-1 items-start">
        <div className="font-sarabun text-neutral_4">{primary}</div>
        <div className="font-sarabun text-neutral_4">{secondary}</div>
      </div>
      <div className="flex-grow"></div>
      <div className="justify-self-end m-1"></div>
    </div>
  )
}

const CBRadioGroupBig = ({
  selectedComponent,
  collapsible = true,
  horizontal = false,
  title = 'Radio Group',
  labels = [],
  subLabels = [],
  values = [],
  icons,
  onChange = (e) => console.log(e),
  selected = -1,
}) => {
  // const [sel, setSel] = useState(selected)

  function renderGroup() {
    if (selected >= 0 && collapsible) {
      return (
        <SelectedRadio
          onClick={(e) => {
            // setSel(-1)
            onChange(-1)
          }}
          selectedComponent={selectedComponent}
          primary={labels[selected]}
          secondary={subLabels[selected]}
          selected={true}
          icon={icons != null ? icons[selected] : null}
        ></SelectedRadio>
      )
    } else {
      return labels.map((e, i) => {
        return (
          <SelectedRadio
            key={i}
            onClick={(e) => {
              // setSel(i)
              if (selected != i) {
                onChange(i)
              }
            }}
            primary={e}
            secondary={subLabels[i]}
            selected={selected == i}
            icon={icons != null ? icons[i] : null}
          ></SelectedRadio>
        )
      })
    }
  }

  return (
    <div className="pt-2 pb-2">
      <div className="mb-2 ml-2 font-sarabun text-2xl">{title}</div>
      <div
        className={`grid gap-4 ${horizontal ? 'grid-cols-3' : 'grid-cols-1'}`}
      >
        {renderGroup()}
      </div>
    </div>
  )
}

const CBRadioGroupBigCalendar = ({
  selectedComponent,
  collapsible = true,
  title = 'Radio Group',
  labels = [],
  subLabels = [],
  values = [],
  icons,
  onChange = (e) => console.log(e),
  selected = null,
}) => {
  //const [sel, setSel] = useState(selected)

  // pull out the primary emails
  const groupedByPrimaryEmails = useMemo(
    () =>
      reduce(
        values,
        (acc, calendar) => {
          const primaryEmail =
            calendar.email + '|' + calendar.calendarAccountType
          // put the primary calendar at the top of the list
          const calendarGroup =
            primaryEmail === calendar.id + '|' + calendar.calendarAccountType
              ? [calendar, ...get(acc, primaryEmail, [])]
              : [...get(acc, primaryEmail, []), calendar]
          return set(acc, [primaryEmail], calendarGroup)
        },
        {}
      ),
    [values]
  )

  // attach primary calendar icons
  const primaryCalendarIcons = useMemo(
    () =>
      reduce(
        values,
        (acc, calendar) => {
          const foundIcon = icons ? icons[calendar.id] : null
          return set(
            acc,
            [calendar.email + '|' + calendar.calendarAccountType],
            foundIcon
          )
        },
        {}
      ),
    [values, icons]
  )

  function renderGroup() {
    if (selected && collapsible) {
      const calendarId = selected.id
      return (
        <SelectedRadio
          onClick={(e) => {
            // setSel(null)
            onChange(null)
          }}
          selectedComponent={selectedComponent}
          primary={selected.summary || selected.name}
          secondary={subLabels[calendarId]}
          selected={true}
          icon={icons != null ? icons[calendarId] : null}
        />
      )
    } else {
      return map(groupedByPrimaryEmails, (calendars, primaryCalendar) => (
        <Accordion
          label={
            <div className="flex">
              {primaryCalendarIcons[primaryCalendar]}
              <p className="text-footnote light mb-0">
                {primaryCalendar.substring(0, primaryCalendar.indexOf('|'))}
              </p>
            </div>
          }
          key={primaryCalendar}
        >
          {map(calendars, (calendar) => {
            const calendarId = calendar.id
            return (
              <SelectedRadio
                key={calendarId}
                onClick={() => {
                  // setSel(calendar)
                  if (selected != calendarId) {
                    onChange(calendar)
                  }
                }}
                primary={calendar.name || calendar.summary}
                secondary={subLabels[calendarId]}
                selected={selected == calendarId}
                icon={icons != null ? icons[calendarId] : null}
              />
            )
          })}
        </Accordion>
      ))
    }
  }

  return (
    <div className="pt-2 pb-2">
      <div className="mb-1 font-sarabun">{title}</div>
      <div className="grid gap-4 grid-cols-1">{renderGroup()}</div>
    </div>
  )
}

const CBRadioGroupBigCalendarMulti = ({
  selectedComponent,
  selectedCalendars,
  collapsible = true,
  title = 'Radio Group',
  labels = [],
  subLabels = [],
  values = [],
  icons,
  onChange = (e) => console.log(e),
  selected = null,
}) => {
  //const [sel, setSel] = useState(selected)

  // pull out the primary emails
  const groupedByPrimaryEmails = useMemo(
    () =>
      reduce(
        values,
        (acc, calendar) => {
          const primaryEmail =
            calendar.email + '|' + calendar.calendarAccountType
          // put the primary calendar at the top of the list
          const calendarGroup =
            primaryEmail === calendar.id + '|' + calendar.calendarAccountType
              ? [calendar, ...get(acc, primaryEmail, [])]
              : [...get(acc, primaryEmail, []), calendar]
          return set(acc, [primaryEmail], calendarGroup)
        },
        {}
      ),
    [values]
  )

  // attach primary calendar icons
  const primaryCalendarIcons = useMemo(
    () =>
      reduce(
        values,
        (acc, calendar) => {
          const foundIcon = icons ? icons[calendar.id] : null
          return set(
            acc,
            [calendar.email + '|' + calendar.calendarAccountType],
            foundIcon
          )
        },
        {}
      ),
    [values, icons]
  )

  function renderGroup() {
    // if (selected && collapsible) {
    //   const calendarId = selected.id
    //   return (
    //     <SelectedRadio
    //       onClick={(e) => {
    //         // setSel(null)
    //         onChange(null)
    //       }}
    //       selectedComponent={selectedComponent}
    //       primary={labels[calendarId]}
    //       secondary={subLabels[calendarId]}
    //       selected={true}
    //       icon={icons != null ? icons[calendarId] : null}
    //     />
    //   )
    // } else {
    return map(groupedByPrimaryEmails, (calendars, primaryCalendar) => (
      <Accordion
        label={
          <div className="flex">
            {primaryCalendarIcons[primaryCalendar]}
            <p className="text-footnote light mb-0">
              {primaryCalendar.substring(0, primaryCalendar.indexOf('|'))}
            </p>
          </div>
        }
        key={primaryCalendar}
      >
        {map(calendars, (calendar) => {
          const calendarId = calendar.id
          return (
            <SelectedRadio
              key={calendarId}
              onClick={() => {
                // setSel(calendar)

                onChange(calendar)
              }}
              primary={calendar.name || calendar.summary}
              secondary={subLabels[calendarId]}
              selected={selectedCalendars.includes(calendar)}
              icon={icons != null ? icons[calendarId] : null}
            />
          )
        })}
      </Accordion>
    ))
    // }
  }

  return (
    <div className="pt-2 pb-2">
      <div className="mb-1 font-sarabun">{title}</div>
      <div className="grid gap-4 grid-cols-1">{renderGroup()}</div>
    </div>
  )
}

const CBCheckItem = ({
  label,
  checked = false,
  onChange = (e) => console.log(e),
  box = false,
  border = true,
  disable = false,
  color="#FF6709", // Default color is the original burnt orange
}) => {
  const [check, setCheck] = useState(checked)
  useEffect(() => {
    setCheck(checked)
  }, [checked])

  // Create styled versions of the SVG components with the custom color
  const StyledCheckOn = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" 
        fill={color} stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8 12L11 15L17 9" stroke="white" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round"/>
    </svg>
  )

  const StyledCheckOff = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" 
        stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )

  return (
    <button
      onClick={(e) => {
        var change = !check

        if (!disable) {
          setCheck(change)
        }

        onChange(change)
      }}
      className={`font-manrope ${box && 'text-lg'} text-neutral_4 ${
        border && 'border-2 border-neutral_1'
      } rounded-sm hover:border-neutral_2  pt-1 pb-1 pl-2 pr-2 lg:pl-4 lg:pr-4 flex space-x-3 items-center cursor-pointer w-full`}
    >
      <div>{label}</div>
      <div className="flex-grow"></div>
      <div className="justify-self-end">
        {check ? (
          box ? (
            <StyledCheckOn />
          ) : (
            <ToggleOn />
          )
        ) : box ? (
          <StyledCheckOff />
        ) : (
          <ToggleOff />
        )}
      </div>
    </button>
  )
}

const CBRadioGroup = ({
  title = 'Selection',
  labels = [],
  values = [],
  onChange = (e) => console.log(e),
  selected = -1,
  center = true,
}) => {
  const selectedButton =
    'p-1 pl-4 pr-4 font-sarabun bg-burnt rounded-sm border border-burnt text-white '
  const unselectedButton =
    'p-1 pl-4 pr-4 font-sarabun rounded-sm border border-neutral_2 text-neutral_4  '
  // const [sel, setSel] = useState(selected)

  return (
    <div
      id={title}
      className={`flex flex-col pt-2 pb-2 ${
        center ? 'justify-center items-center' : ''
      }`}
    >
      <div className="mb-2 font-sarabun flex-1"> {title}</div>
      <div className="flex flex-row gap-x-2 ">
        {labels.map((e, i) => {
          return (
            <div key={i}>
              <button
                onClick={(e) => {
                  if (selected == i) {
                    // setSel(i)
                  } else {
                    // setSel(i)
                    onChange(i)
                  }
                }}
                className={selected == i ? selectedButton : unselectedButton}
              >
                {e}
              </button>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export {
  CBCheckItem, CBRadioGroup, CBRadioGroupBig, CBRadioGroupBigCalendar,
  CBRadioGroupBigCalendarMulti, CurrentPlan
}
